module.exports = {
      id: "83bf6b6e08ca221aeaa274270b9b0b78electricity-disconnected.svg-usage",
      viewBox: "0 0 595.3 841.9",
      url: __webpack_public_path__ + "sprite.svg#83bf6b6e08ca221aeaa274270b9b0b78electricity-disconnected.svg",
      toString: function () {
        return this.url;
      }
    }